/* Component Dependencies */
var createOnlineAccountLinkTemplate = require('templates/createOnlineAccountLink.hbs');
var AriesComponent = require('libs/aries-component');

AriesComponent.create({
  type: 'createOnlineAccountLink',
  template: {
    'createOnlineAccountLink': createOnlineAccountLinkTemplate
  },
  unBindEvents: function($) {
    $('*[data-component-id="' + this.$el.data('component-id') + '"]').off();
    $('*[data-component-id="' + this.$el.data('component-id') + '"] *').off();
  }
});
